import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';
import {User} from '../../../model/user';
import {selectUser} from '../../../store/user/selectors/user.selectors';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../../store/user/reducers/user.reducer';

@Component({
    selector: 'app-insurance-contract-detail-advertisement-info',
    templateUrl: './insurance-contract-detail-advertisement-info.component.html',
    styleUrls: ['./insurance-contract-detail-advertisement-info.component.scss'],
    standalone: false
})
export class InsuranceContractDetailAdvertisementInfoComponent {

  @Input() insuranceContract: Proposal;
  @Input() usersAllowedToView: User[];

  user$ = this.userStore.select(selectUser);

  constructor(private readonly userStore: Store<UserAppState>) {
  }

}
